<template>
    <v-responsive :aspect-ratio="16/9">
        <jw-player v-if="source === 'jwplayer'" :video-link="videoLink"/>

        <iframe
            v-else-if="videoLink"
            :id="id"
            :src="videoLink"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
        ></iframe>
    </v-responsive>
</template>

<style scoped>
iframe {
    border: 0;
    width: 100%;
    height: 100%;
}
</style>

<script>
import JwPlayer from './JWPlayer';

export default {
    name: 'VideoElement',
    props: {
        source: String,
        id: String,
    },
    components: {
        JwPlayer,
    },
    computed: {
        videoLink() {
            if (this.source === 'vimeo') {
                return `https://player.vimeo.com/video/${this.id}?title=0&byline=0`;
            } else if (this.source === 'youtube') {
                return `https://www.youtube.com/embed/${this.id}?enablejsapi=1`;
            } else if (this.source === 'jwplayer') {
                return this.id;
            }
        },
    },
};
</script>